import { render, staticRenderFns } from "./AccountRemoval.vue?vue&type=template&id=49fe2948&"
import script from "./AccountRemoval.vue?vue&type=script&lang=js&"
export * from "./AccountRemoval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports